import {
  FetchArgs,
  createApi,
  fetchBaseQuery,
  retry,
} from "@reduxjs/toolkit/query/react";
import { loader } from "./staticApi";
import { clearSessionStorage, GetSessionStorageData } from "../../utilities/helper";
import { Modal } from "antd";
import { TOKENS } from "../../utilities/Constants/Constants";
import { showErrorToast } from "../../utilities/toastUtils";

// Function to handle showing the modal
const showUnauthorizedModal = () => {
  Modal.warning({
    title: 'Unauthorized',
    content: 'Your session has expired. Please log in again.',
    centered: true,
    className: "warningModal",
    onOk: () => {
      // Redirect to login or take appropriate action
      window.location.href = '/login'; // Replace with your login route
      clearSessionStorage();
    },
  });
};

const baseQuery = fetchBaseQuery({ 
  baseUrl: process.env.REACT_APP_BASE_BACKEND_API_URL || "https://web-backend-service-fzrkutbmyq-uc.a.run.app/",
  prepareHeaders: async (headers) => {
    const accessToken = GetSessionStorageData(TOKENS.ACCESS_TOKEN);
    if (accessToken) {
      headers.set("Authorization", "Bearer " + accessToken);
    }
    return headers;
  },
});

//used for token handle and common response and error

const staggeredBaseQueryWithBailOut = retry(
  async (args: string | FetchArgs, api, extraOptions) => {
    api.dispatch(loader(true));
    let result = await baseQuery(args, api, extraOptions);
    if (result?.error?.status === "FETCH_ERROR") {
      showErrorToast("Network error");
    }

    if (result?.error && result?.error?.status === 401) {
      // Show the modal on 401 error
      showUnauthorizedModal();
    }

    if (result) {
      api.dispatch(loader(false));
    }
    return result;
  },
  {
    maxRetries: 0,
  }
);

export const baseApi = createApi({
  reducerPath: "baseApiReducer",
  baseQuery: staggeredBaseQueryWithBailOut,
  tagTypes: ["dashboard", "workbench", "semanticModel"],
  endpoints: () => ({}),
});
